import { render, staticRenderFns } from "./AdviserSettingsEducationInfo.vue?vue&type=template&id=188de6a0&"
import script from "./AdviserSettingsEducationInfo.vue?vue&type=script&lang=js&"
export * from "./AdviserSettingsEducationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports